import Molde from "./MoldeTourTradicionalTrek";
import CardLugar from "../common/card/CardLugar";
import CardRecomienda from "../common/card/CardRecomienda";
import CardCaracteristica from "../common/card/CardCaracteristica";
import React from 'react';


export default function montaniaPalcoyo() {
  return (
    <>
      <Molde
        image={"/images/portada-palcoyo.png"}
        title={"MONTAÑA PALCOYO"}
        subtitle={"(FULL DAY)"}
        description={
          "La montaña Palcoyo es muy semejante a la conocida montaña de 7 colores Vinicunca y por eso sabemos que para algunos viajeros es un tanto difícil decidir a cual montaña ir en sus paseos cuando están por Cusco. Ahora para ayudar en esta decisión que es muy importante describiremos las razones por las cuales habría que incluir Palcoyo en su lista de paseos.Cuando el número de visitantes aumentaba en mucha cantidad a la montaña de 7 colores en el 2017, fue cuando los pobladores de Palcoyo (una comunidad andina) se dieron cuenta que ellos también poseían un atractivo que se parecía a la montaña de 7 colores. Ellos tenían las montañas coloradas de Palcoyo, que solo ellos lo conocían.se organizaron internamente. Entendieron de los beneficios que traía la actividad turística. Comenzaron a promocionar y abrir camino hacia esas montañas coloradas, que son tres en total y todavía como un plus tiene su bosque de piedras que completa el adorno del paisaje. Así fue que Palcoyo se hizo conocer durante el año 2018, fue por todo el Perú y siguió alrededor del mundo. Gracias a sus visitantes que cada vez más recomendaron como un paseo alternativo a la montaña de 7 colores."
        }
        linkForm={"/reservar/citytour-dia"}
        /*tipoprecio={"Precio por persona"}
        monto={"US$ 40.00"}
        moneda={"DOLARES"}*/
        mapa={
          <>
            <div>
              <h1 className="text-primary-800 font-bold">UBICACIÓN</h1>
            </div>
            <img className="rounded-lg border-primary-800 border-2" src={`${process.env.PUBLIC_URL}/images/mapa_palcoyo.png`} alt="" />
          </>
        }
        galeria={
            <>
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/palco_1.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/palco_2.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/palco_3.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/palco_4.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/palco_5.png`} alt="" />
              <img className="rounded-lg" src={`${process.env.PUBLIC_URL}/images/palco_6.png`} alt="" />
            </>
          }
        incluye={
          <>
            <li>Transporte turistico</li>
           
            <li>Asistencia permanente</li>
            <li>Desayuno buffet</li>
            <li>Almuerzo buffet</li>
          </>
        }
        noIncluye={
          <>
            <li>Pago de ingreso</li>
            <li>Alquiler de caballo</li>
            <li>Gastos extra</li>
          </>
        }
        recomendaciones={
          <>
            <li>Bloqueador solar.</li>
            <li>Poncho en caso de lluvia.</li>
            <li>Gorra, sombrero, guantes, lentes de sol.</li>
            <li>Botella con agua.</li>
            <li>Cortavientos, pantalón de trekking.</li>
            <li>Zapatillas ideales para trekking.</li>
            <li>Snacks, cámara fotográfica, documentos, dinero extra.</li>
          </>
        }
        caracteristica={
          <>
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/level.svg`}
              title={"Dificultad"}
              desc={"Dificil"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/compartido.svg`}
              title={"Tipo Servicio"}
              desc={"Compartido"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/duracion.svg`}
              title={"Duración"}
              desc={"Full day"}
            />
            <CardCaracteristica
              icon={`${process.env.PUBLIC_URL}/icons/cultural.svg`}
              title={"Tipo de Tour"}
              desc={"Trek"}
            />
          </>
        }
        lugarvisita={
          <>
            <CardLugar
              icon={"/icons/street-view-solid.svg"}
              title={"Cusipata"}
            />
            <CardLugar
              icon={"/icons/street-view-solid.svg"}
              title={"Vinicunca"}
            />
            
          </>
        }
        TourRecomienda={
        <>
            <CardRecomienda
                img={"/images/montania_colores.png"}
                title={"MONTAÑA 7 COLORES"}
                puntuacion={"4.5"}
                link={'/tour-tradicional/montania-colores'}
            />
            <CardRecomienda
                img={"/images/valle-vip-5.png"}
                title={"VALLE VIP"}
                puntuacion={"5"}
                link={'/tour-tradicional/valle-vip'}
            />
            <CardRecomienda
                img={"/images/cris-1.png"}
                title={"CITY TOUR"}
                puntuacion={"5"}
                link={'/tour-tradicional/citytour'}
            />
            <CardRecomienda
                img={"/images/maras-moray-4.png"}
                title={"MARAS-MORAY"}
                puntuacion={"4.5"}
                link={'/tour-tradicional/maras-moray'}
            />
        </>
    }
      />
    </>
  );
}
